import { NgModule } from '@angular/core';
import { CommonModule, } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { Routes, RouterModule } from '@angular/router';

import { NotFoundComponent } from './views/pages/not-found/not-found.component';
import { ForbiddenComponent } from './views/pages/forbidden/forbidden.component';
import { environment } from 'src/environments/environment';
import { AuthLayoutComponent } from './views/layouts/auth-layout/auth-layout.component';
import { AdminLayoutComponent } from './views/layouts/admin-layout/admin-layout.component';
import { HomeLayoutComponent } from './views/layouts/home-layout/home-layout.component';
import { AuthGuardService } from './modules/auth/services/auth-guard.service';

const routes: Routes = [
  {
    path: "admin",
    component: AdminLayoutComponent,
    loadChildren: () => import('src/app/modules/admin/admin.module').then(m => m.AdminModule),
    canActivate: [AuthGuardService]
  },
  {
    path: "auth",
    component: AuthLayoutComponent,
    loadChildren: () => import('src/app/modules/auth/auth.module').then(m => m.AuthModule),
  },
  {
    path: 'home',
    data: { title: "Home" },
    component: HomeLayoutComponent,
  },
  { path: '404', component: NotFoundComponent },
  { path: '403', component: ForbiddenComponent },
  { path: '', redirectTo: '/auth/login', pathMatch: "prefix" }, { path: '**', redirectTo: '404', pathMatch: "full" },
];

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule.forRoot(routes, {
      useHash: true
    })
  ],
  exports: [
  ],
})
export class AppRoutingModule { }
